import { useCallback, useMemo } from 'react';

import { useMostPopularBetsStore } from '../context/MostPopularBetsContext';

export const useBetslip = ({
  betId,
  betName,
  betOdds,
  bookieCode,
  marketName,
  subeventName,
}: {
  betId: number;
  betName?: string;
  betOdds?: string | number;
  bookieCode: string;
  marketName?: string;
  subeventName?: string;
}) => {
  const selectedBets = useMostPopularBetsStore(state => state.selectedBets);
  const addSelectedBet = useMostPopularBetsStore(state => state.addSelectedBet);
  const removeSelectedBet = useMostPopularBetsStore(state => state.removeSelectedBet);

  // Each Most Popular Bets row renders a single best-odds button per bet, so a bet is
  // "selected" purely by its betId. We deliberately do NOT also match on bookieCode: the
  // authoritative betslip resolves the best-odds bookmaker from a different feed than the
  // popular-bets API, so its bookieCode can differ from this row's bestOddsBookmakerCode.
  // Matching on bookieCode dropped the green highlight the moment the betslip synced back.
  const isBookieBetSelected = useMemo(() => selectedBets.some(bet => bet.betId === betId), [betId, selectedBets]);

  const toggleBetslipBet = useCallback(() => {
    try {
      window.bettingActions.addOrRemoveFromBetslip(
        [{ betId, selectedBookie: bookieCode }],
        [betId],
        bookieCode,
        betOdds?.toString(),
        betName,
        'most-popular-bets',
        subeventName,
        marketName,
        'n/a',
      );
    } catch (e) {
      console.error('useBetslip.toggleBetslipBet', e);
    }

    isBookieBetSelected ? removeSelectedBet(betId) : addSelectedBet({ betId, bookieCode });
  }, [
    isBookieBetSelected,
    removeSelectedBet,
    betId,
    addSelectedBet,
    bookieCode,
    betOdds,
    betName,
    subeventName,
    marketName,
  ]);

  return { isBookieBetSelected, toggleBetslipBet };
};
